import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-pedido-itens-erro-inline',
  templateUrl: './pedido-itens-erro-inline.component.html',
  styleUrls: ['./pedido-itens-erro-inline.component.scss'],
  standalone: false
})
export class PedidoItensErroInlineComponent {
  @Input() mensagem: string | null = null;
}
